module.exports = __webpack_public_path__ + "img/logo.3dbd90e8.svg";